import { render, staticRenderFns } from "./VisualizacaoEmCard.vue?vue&type=template&id=24fd9e74"
import script from "./VisualizacaoEmCard.vue?vue&type=script&lang=js"
export * from "./VisualizacaoEmCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports